/**
 * src/utils/roleUtils.js
 *
 * Single source of truth for role normalization across the HRMS app.
 *
 * Normalizes Firestore role variations to standard application roles:
 *   "admin" | "hr" | "finance" | "lead" | "employee"
 *
 * Supported Firestore role values:
 *   - "Reporting Manager", "reporting_manager", "manager", "team_lead", "Team Lead", "lead" -> "lead"
 *   - "Admin", "admin", "Administrator" -> "admin"
 *   - "HR", "hr", "Human Resources" -> "hr"
 *   - "Finance", "finance" -> "finance"
 *   - "Employee", "employee", "Staff" -> "employee"
 */
export function normalizeRole(role) {
  if (!role) return "";
  const r = String(role).trim().toLowerCase().replace(/[\s_-]+/g, "");
  if (r.includes("admin") || r === "administrator") return "admin";
  if (r === "hr" || r.startsWith("hr") || r.includes("humanresource")) return "hr";
  if (r.includes("finance") || r.includes("accountant")) return "finance";
  if (
    r.includes("lead") ||
    r.includes("manager") ||
    r.includes("supervisor")
  ) {
    return "lead";
  }
  if (r.includes("employee") || r.includes("staff") || r.includes("intern")) return "employee";
  return r;
}
